import { useEffect, useState, type ReactNode } from 'react';
import { Box } from '@mui/material';

export function LazyTabPanel(props: {
    value: number;
    index: number;
    children: ReactNode;
}) {
    const { value, index, children } = props;
    const [visited, setVisited] = useState(value === index);

    useEffect(() => {
        if (value === index) setVisited(true);
    }, [value, index]);

    if (!visited) return null;
    return <Box sx={{ pt: 2, display: value === index ? 'block' : 'none' }}>{children}</Box>;
}
